/**
 * Cookie utilities for dextoro Launch
 */

import { debug } from "@/lib/debug";

const COOKIE_NAME = 'dextoro_hw_ack';
const MAX_AGE_SECONDS = 31536000; // 365 days

export function hasAcknowledgedHowItWorks(): boolean {
  debug.trace('[HowItWorks] Checking acknowledgement cookie');
  return document.cookie.split('; ').some(row => row.startsWith(`${COOKIE_NAME}=`));
}

export function setHowItWorksAcknowledged(): void {
  const isSecure = window.location.protocol === 'https:';
  const securePart = isSecure ? '; Secure' : '';
  document.cookie = `${COOKIE_NAME}=1; path=/; max-age=${MAX_AGE_SECONDS}; SameSite=Lax${securePart}`;
  debug.trace('[HowItWorks] User acknowledged - cookie set');
}
